import { apiError, authClient } from '@/lib/api/ts-rest';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useMfaResend = () => {
  const mutation = useMutation({
    mutationFn: async (challengeId: string) => {
      const res = await authClient.resendMfa({ body: { challengeId } });
      if (res.status !== 200) throw apiError(res, 'Resend failed');
      return res.body;
    },
    onSuccess: () => {
      toast.success('Un nouveau code a été envoyé à votre adresse email.');
    },
    onError: (error: Error) => {
      toast.error(
        error.message || 'Impossible de renvoyer le code. Veuillez réessayer.'
      );
    },
  });

  return {
    resendCode: mutation.mutate,
    isLoading: mutation.isPending,
    newChallengeId: mutation.data?.challengeId,
  };
};
